<script context="module">
    import {doShow} from "./store"
    import {get, writable} from 'svelte/store'

    const visible = writable()

    let showed = false

    doShow.subscribe((value) => {
        showed = false

        if (value.status && value.text) {
            visible.set(true)
        }
    })
</script>

<script>
    import Close from 'src/components/#common/#assets/close.svg'
    import { fade } from 'svelte/transition'
    import {onDestroy} from "svelte";

    if (showed) {
        $visible = false
    }

    let showedTimer

    $: if ($visible) {
        if (showedTimer) {
            clearTimeout(showedTimer)
        }

        showedTimer = setTimeout(function (){
            showed = true
        }, 2000)

        window.document.documentElement.scrollTop = 0
    } else {
        if (showedTimer) {
            clearTimeout(showedTimer)
            showedTimer = null
        }
    }

    onDestroy(() => {
        if (showedTimer) {
            clearTimeout(showedTimer)
        }
    })
</script>

{#if $visible}
    <div class="alerts" transition:fade style="
        --Close:url({Close});
    ">
        <div class="alert alert-{$doShow.status}">
            <button type="button" on:click={() => { $visible = false }} class="btn-close"></button>
            {$doShow.text}
        </div>
    </div>
{/if}

<style>
    .alerts {
        position: relative;
    }

    .alert {
        color: white;
        border-radius: 4px;
        padding: 10px 50px;
        font-size: 16px;
        text-align: center;
        line-height: normal;
        border: 0;
        margin-bottom: 20px;
    }

    .alert-success {
        background: #48a24c;
    }

    .alert-message {
        background: #d09540;
    }

    .alert-error {
        background: #ce4036;
    }

    .btn-close {
        position: absolute;
        background: var(--Close) no-repeat;
        top: 10px;
        right: 12px;
        font-size: 14px;
        opacity: 0.7;
        box-shadow: none !important;
        width: 18px;
        height: 18px;
        padding: 0;
        transition: .25s;
    }

    .btn-close:hover {
        opacity: 0.9;
    }
</style>
